<i [ngClass]="icon" class="context-menu-item__icon" [style.fontSize.px]="iconSize" [style.color]="iconColor"></i>
<div class="context-menu-item__name">{{ name }}</div>
@if (isSelectFile) {
  <input type="file" class="context-menu-item__file" [multiple]="true" (change)="onSelectFile.emit($event.target)" />
}
